module.exports = __webpack_public_path__ + "img/icon_haken_gruen.8cf18375.svg";